// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Admin-newsEdit-___newsEdit__container___2nBn4","top-list":"src-components-Admin-newsEdit-___newsEdit__top-list___aF-vd","date-input":"src-components-Admin-newsEdit-___newsEdit__date-input___1JFHP","title":"src-components-Admin-newsEdit-___newsEdit__title___kFf-A","save-button":"src-components-Admin-newsEdit-___newsEdit__save-button___UAZ4n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/newsEdit/newsEdit.css
// module id = 1083
// module chunks = 0